import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Products", href: "#products" },
  { label: "Buy", href: "#buy" },
  { label: "Facility", href: "#facility" },
  { label: "Vision", href: "#vision" },
  { label: "Enquire", href: "#quote" },
];

const Brand = () => (
  <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
    <span className="block h-14 overflow-hidden rounded-xl ring-1 ring-[var(--mx-line-strong)] md:h-16">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-label="Metalix animated logo"
        className="h-full w-auto"
      >
        <source src="/metalix-mark.webm" type="video/webm" />
        <source src="/metalix-mark.mp4" type="video/mp4" />
      </video>
    </span>
    <span className="flex flex-col leading-none">
      <span className="font-display text-3xl font-extrabold tracking-tight text-[var(--mx-ink)]">
        Metal<span className="text-[var(--mx-copper)]">ix</span> XT
      </span>
      <span className="mt-1 flex w-full justify-between font-mono-tech text-[10px] uppercase text-[var(--mx-ink-2)]">
        {"Private Limited".split("").map((c, i) => (
          <span key={i}>{c === " " ? "\u00A0" : c}</span>
        ))}
      </span>
    </span>
  </a>
);

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "border-b border-[var(--mx-line)] bg-[var(--mx-bg)]/80 py-4 backdrop-blur-xl"
          : "border-b border-transparent py-6"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-10">
        <Brand />

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)] transition-colors duration-300 hover:text-[var(--mx-copper)]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-cta"
            className="group relative overflow-hidden rounded-full bg-[var(--mx-copper)] px-6 py-2.5 font-mono-tech text-xs uppercase tracking-widest text-white"
          >
            <span className="relative z-10">Request Quote</span>
            <span className="absolute inset-0 -translate-y-full bg-[var(--mx-charcoal)] transition-transform duration-300 group-hover:translate-y-0" />
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink)] md:hidden"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="border-t border-[var(--mx-line)] bg-[var(--mx-bg)]/95 px-6 py-6 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 font-display text-2xl font-bold uppercase text-[var(--mx-ink)]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
